import { render } from "./DynvibeWordCloud.vue?vue&type=template&id=27f6088c&scoped=true"
import script from "./DynvibeWordCloud.vue?vue&type=script&lang=js"
export * from "./DynvibeWordCloud.vue?vue&type=script&lang=js"

import "./DynvibeWordCloud.vue?vue&type=style&index=0&id=27f6088c&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f6088c"]])

export default __exports__